import { Business as BusinessIcon } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Button, Card, Stack, TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { getStartedCardSx, getStartedHeaderSx, StepHeader } from './getStartedShared';

export default function GetStartedOrgStep({ orgForm, setOrgForm, orgComplete, savingStep, onSave, onSkip }) {
  const { t: translate } = useTranslation();
  const theme = useTheme();

  return (
    <Card sx={getStartedCardSx(theme)}>
      <Stack spacing={2.5}>
        <Stack sx={getStartedHeaderSx(theme)}>
          <StepHeader
            icon={<BusinessIcon />}
            title={translate('get_started_page.organization.title', { defaultValue: 'Create organization' })}
            description={translate('get_started_page.organization.description', {
              defaultValue: 'Set the organization name shown across the workspace.',
            })}
            done={orgComplete}
          />
        </Stack>
        <Stack spacing={2} sx={{ maxWidth: 760 }}>
          <TextField
            fullWidth
            label={translate('get_started_page.organization.name_label', { defaultValue: 'Organization name' })}
            value={orgForm.org_name}
            disabled={orgComplete}
            onChange={(event) => setOrgForm((prev) => ({ ...prev, org_name: event.target.value }))}
          />
          <TextField
            fullWidth
            multiline
            minRows={3}
            label={translate('get_started_page.organization.description_label', {
              defaultValue: 'Organization description',
            })}
            value={orgForm.org_description}
            disabled={orgComplete}
            onChange={(event) => setOrgForm((prev) => ({ ...prev, org_description: event.target.value }))}
          />
        </Stack>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end">
          {!orgComplete && (
            <Button disabled={savingStep === 'org'} onClick={onSkip}>
              {translate('get_started_page.skip', { defaultValue: 'Skip' })}
            </Button>
          )}
          <LoadingButton
            variant="contained"
            loading={savingStep === 'org'}
            disabled={orgComplete}
            onClick={onSave}
            sx={{ minWidth: 160 }}
          >
            {translate('get_started_page.organization.save_button', { defaultValue: 'Save organization' })}
          </LoadingButton>
        </Stack>
      </Stack>
    </Card>
  );
}
